import React from "react";
import { Box } from "@mui/material";
import {
  AgronodDialog,
  AgronodButton,
  AgronodTypography,
  AgronodAlert,
} from "@agronod/mui-components";
import { useControlShares } from "@/hooks/useShares";

interface DeleteControlDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  controlId: string | null;
  controlName?: string;
  isDeleting?: boolean;
}

/**
 * Reusable delete control confirmation dialog
 * Shows a warning if the control has an active share
 */
const DeleteControlDialog: React.FC<DeleteControlDialogProps> = ({
  open,
  onClose,
  onConfirm,
  controlId,
  controlName,
  isDeleting = false,
}) => {
  // Check if control has an active share
  const { activeShare } = useControlShares(controlId || "");
  const hasActiveShare = !!activeShare;

  return (
    <AgronodDialog
      open={open}
      onClose={onClose}
      title="Ta bort kontroll"
      actions={
        <>
          <AgronodButton onClick={onClose}>Avbryt</AgronodButton>
          <AgronodButton
            onClick={onConfirm}
            color="error"
            variant="contained"
            disabled={isDeleting}
          >
            {isDeleting ? "Tar bort..." : "Ta bort"}
          </AgronodButton>
        </>
      }
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {hasActiveShare && (
          <AgronodAlert severity="warning">
            Denna kontroll har en aktiv delning. Om du tar bort kontrollen kommer
            inspektören inte längre kunna komma åt dokumenten.
          </AgronodAlert>
        )}
        <AgronodTypography>
          Är du säker på att du vill ta bort{" "}
          {controlName ? `kontrollen "${controlName}"` : "denna kontroll"}? Denna
          åtgärd kan inte ångras och alla associerade dokument och delningar
          kommer att tas bort.
        </AgronodTypography>
      </Box>
    </AgronodDialog>
  );
};

export default DeleteControlDialog;
